import { signal } from '@preact/signals';

const STORAGE_KEY = 'controls-overlay-seen';

const hasSeenControls = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

const markControlsSeen = (): void => {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // Ignore storage errors
  }
};

export type ControlsPhase = 'visible' | 'hidden';

export const controlsPhase = signal<ControlsPhase>(hasSeenControls() ? 'hidden' : 'visible');

export const openControlsOverlay = (): void => {
  controlsPhase.value = 'visible';
};

export const closeControlsOverlay = (): void => {
  controlsPhase.value = 'hidden';
  markControlsSeen();
};
